export default "__VITE_ASSET__3f2V6W2U__"